import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GlobalService {
    private readonly showLoaderSignal = signal<boolean>(false);
    private readonly showToastSignal = signal<{ message: string; type: string } | null>(null);

    readonly showLoaderState = this.showLoaderSignal.asReadonly();
    readonly showToastState = this.showToastSignal.asReadonly();

    showLoader(show: boolean): void {
        this.showLoaderSignal.set(show);
    }
    showToast(message: string, type: string): void {
        this.showToastSignal.set({ message: message, type: type });
    }
}